export enum CollectionPoolTypeId {
    NPCP = 1,
    PCP = 2,
    W10DD = 3,
    W10DDPROD = 7,
    W10PD = 4,
    W10PDPROD = 8
}
